/**
 * Decodes HTML entities to their corresponding characters
 * @param str String containing HTML entities
 * @returns Decoded string
 */
export const decodeHtmlEntities = (str: string): string => {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
};

/**
 * Parses various boolean formats from WordPress/WooCommerce
 * @param value Value to parse ('1', 'true', true, etc.)
 * @returns Parsed boolean value
 */
export const parseBooleanMeta = (value: any): boolean => {
    return value === '1' || value === 'true' || value === true;
}; 